import { defineMessages } from "react-intl";

const messages = defineMessages({
    unknown: {
        id: "general.unknown",
    },
});

export default messages;
